import React from 'react'
import { Card, PageHeader, Empty, Spin } from 'antd'
import useSWR from 'swr'
import { useSnapshot } from 'valtio'

import tableStore from '../../lib/store/login_activity_table'
import LoginActivityService from '../../network/services/login_activity'
import { serialize } from '../../network/request'
import LoginActivityTable from './LoginActivityTable'

const LoginActivityPage = () => {
  return (
    <PageHeader title="All Activities">
      <Card>
        <LoginActivityTableWrapper />
      </Card>
    </PageHeader>
  )
}

const LoginActivityTableWrapper = () => {
  const { state } = useSnapshot(tableStore)

  // use this to preload
  const { data: response, error } = useSWR(
    serialize(LoginActivityService.getAll, { page: 1, limit: state.pageSize, ...state.filters })
  )

  console.log(response)

  if (error) {
    console.log(error)
    return <Empty description={error?.message ?? 'Please try again later'} />
  }

  if (!response) {
    return <Spin />
  }

  const { total } = LoginActivityService.toPaginate(response)

  return (
    <>
      <LoginActivityTable total={total} />
      {/* preload next page */}
      {state.currentPage * state.pageSize < total && (
        <div style={{ display: 'none' }}>
          <LoginActivityTable total={total} overridePage={state.currentPage + 1} />
        </div>
      )}
    </>
  )
}

export default LoginActivityPage
